'use strict';

define('lib/helpers/if_eq',['Handlebars'], function (Handlebars) {
  Handlebars.registerHelper('if_eq', function (a, b, opts) {
    if (a == b) { // Or === depending on your needs
      return opts.fn(this);
    }
    return opts.inverse(this);
  });
});

